<sw-modal
    v-show="showModal"
    :title="modalTitle"
    @modal-close="onCancel"
>
    <mt-select
        required
        v-model="entity.prefix"
        :options="presetOptions"
        :label="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.labelProviderType')"
        :placeholder="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.placeholderProviderType')"
    ></mt-select>

    <template v-if="selectedProvider">
        <p class="tdlc-provider-catalog-info">
            {{ selectedProvider.baseUrl }}<template v-if="selectedProvider.modelsEndpoint">&nbsp;&middot;&nbsp;models: {{ selectedProvider.modelsEndpoint }}</template>
        </p>
    </template>

    <sw-password-field
        v-model="entity.secretKey"
        :required="isNew"
        :label="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.labelSecret')"
        :placeholder="maskedSecret || $tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.placeholderSecret')"
        :helpText="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.helpSecret')"
    ></sw-password-field>

    <mt-switch
        v-model="entity.active"
        :label="$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.labelActive')"
    ></mt-switch>

    <template #modal-footer>
        <sw-button size="small" @click="onCancel">
            {{ $tc('global.default.cancel') }}
        </sw-button>
        <sw-button variant="primary" size="small" @click="onSave" :isLoading="isLoading">
            {{ $tc('global.default.save') }}
        </sw-button>
    </template>
</sw-modal>
